module.exports = __webpack_public_path__ + "img/app-image.8dad911b.jpg";